import { ChangeEvent, FocusEvent, memo, useRef } from 'react';
import Modal from '@bridebook/web/app-shared/components/modal';
import { AutocompletePrediction } from '@bridebook/web/app-shared/lib/search/types';
import { AutocompleteTextInput } from './autocomplete-text-input';
import { IGooglePredictionsContext } from './context';
import { CrossBoldIcon, SearchIcon } from './icons';
import { LocationResults } from './location-results';

interface IProps {
  showModal: boolean;
  closeModal(): void;
  label?: string;
  showSearchResults: boolean;
  inputPlaceholder: string;
  value: string;
  onChange(e: ChangeEvent<HTMLInputElement>): void;
  onBlur(e: FocusEvent<HTMLInputElement>): void;
  onClickCb(
    prediction: AutocompletePrediction,
    googlePredictions: IGooglePredictionsContext['googlePredictions'],
  ): void;
  onEscape(e: KeyboardEvent): void;
  setResultsPosition(position: 'top' | 'bottom'): void;
}

const LocationModalAutocomplete = ({
  showModal,
  closeModal,
  label,
  showSearchResults,
  inputPlaceholder,
  value,
  onChange,
  onBlur,
  onClickCb,
  onEscape,
  setResultsPosition,
}: IProps) => {
  const wrapperRef = useRef<HTMLDivElement>(null);

  return (
    <Modal id="mobile-location-modal" show={showModal} onClose={closeModal}>
      <div className="bsmob">
        <div className="bsmob-head">
          <span className="bsmob-label">{label}</span>
          <div className="bsmob-close" onClick={closeModal}>
            <CrossBoldIcon width={14} height={14} className="text-space-40" />
          </div>
        </div>
        <div className="bsauto-wrap" ref={wrapperRef}>
          <div className="p-4">
            <AutocompleteTextInput
              label={label}
              dataTest="autocomplete-input-location"
              onChange={onChange}
              onBlur={onBlur}
              placeholder={inputPlaceholder}
              value={value}
              afterInput={
                <SearchIcon width={18} height={18} className="mx-4 shrink-0 text-indigo-crush" />
              }
              autoFocus
              className="rounded-2xl"
            />
          </div>
          {showSearchResults && (
            <LocationResults
              input={value}
              onClick={onClickCb}
              parentRef={wrapperRef.current}
              onEscape={onEscape}
              onPositionChange={setResultsPosition}
            />
          )}
        </div>
      </div>
    </Modal>
  );
};

export default memo(LocationModalAutocomplete);
